import axios, {AxiosResponse} from 'axios';
import {apiUrl} from '@/env';
import {getLocalToken} from '@/utils';
import {eventBus} from '@/main.ts';

// import store from "@/store";
//
// const token = store.state.main.token || localStorage.getItem('token')

const authHeaders = (params: any = {}) => {
  // @ts-ignore
  const token = getLocalToken();
  return {
    headers: {
     Authorization: `Bearer ${token}`,
    },
    params,
  };
};

export const get = async <T>(endpoint_path: string, params: any = {}): Promise<AxiosResponse<T>> => {
  // @ts-ignore
  eventBus.$emit('SHOW_LOADING', true);
  try {
    return await axios.get<T>(`${apiUrl}/api/v1/${endpoint_path}`, authHeaders(params));
  } finally {
    // @ts-ignore
    eventBus.$emit('SHOW_LOADING', false);
  }
};

export const axiosDelete = (endpoint_path: string): Promise<AxiosResponse> => {
  // @ts-ignore
  eventBus.$emit('SHOW_LOADING', true);

  try {
   return axios.delete(`${apiUrl}/api/v1/${endpoint_path}`, authHeaders());
  } finally {
    // @ts-ignore
    eventBus.$emit('SHOW_LOADING', false);
  }
};

// export function post (url, params, config) {
//   const fd = new FormData()
//   params = params || {}
//   Object.keys(params).forEach((k) => {
//     fd.append(k, params[k])
//   })
//   config = config || {}
//   config.headers = process.server ? fd.getHeaders() : config.headers || {} // passa os headers no ss pra nao quebrar a request
//
//   return axios.post(url, fd, config)
// }
